import React from 'react';
import {
  ModalDigitalDocumentsContainer,
  ModalDigitalDocumentsContent,
  ModalDigitalDocumentsHead,
  ModalDigitalDocumentsBody,
  ModalDigitalDocumentsFooter,
  ModalDigitalDocumentsTitle,
  ModalDigitalDocumentsIconContent,
  ModalDigitalDocumentsIcon
} from './styles';
import { IoClose } from 'react-icons/io5';
import colors from '../../assets/styles/colors';
import { SecondaryLargeButton } from '../Buttons/styles';

const ModalDigitalDocuments = ({ open, setShowModal, title, body }) => {
  return (
    <ModalDigitalDocumentsContainer open={open} id="modal-digital-documents">
      <ModalDigitalDocumentsContent>
        <ModalDigitalDocumentsHead setShowModal={setShowModal}>
          {setShowModal && <IoClose size={26} color={colors.textSecondary} onClick={() => setShowModal(false)} id="close-icon" />}
        </ModalDigitalDocumentsHead>
        <ModalDigitalDocumentsTitle>{title}</ModalDigitalDocumentsTitle>
        <ModalDigitalDocumentsBody>
          {body.map(item =>(
            <ModalDigitalDocumentsIconContent>
              <ModalDigitalDocumentsIcon background={item.backgroundIcon}>
                {item.image}
              </ModalDigitalDocumentsIcon>
              {item.description}
            </ModalDigitalDocumentsIconContent>
          ))}
        </ModalDigitalDocumentsBody>
        <ModalDigitalDocumentsFooter>
          <SecondaryLargeButton onClick={() => setShowModal(false)}>Continuar</SecondaryLargeButton>
        </ModalDigitalDocumentsFooter>
      </ModalDigitalDocumentsContent>
    </ModalDigitalDocumentsContainer>
  )
}

export default ModalDigitalDocuments;
